import { render, staticRenderFns } from "./ThreadForm.vue?vue&type=template&id=7f97bd0c&scoped=true&"
import script from "./ThreadForm.vue?vue&type=script&lang=js&"
export * from "./ThreadForm.vue?vue&type=script&lang=js&"
import style0 from "./ThreadForm.vue?vue&type=style&index=0&id=7f97bd0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f97bd0c",
  null
  
)

export default component.exports